export default __webpack_public_path__ + "static/media/magic-wand.4d572d1b.png";